import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Theme } from "@silvertours/front-shared";
import { useMedia } from "react-use";
import { useBrand, useHost } from "../Runtime";
import { FloytLogo } from "./brands/FloytLogo";
import { BMLogo } from "./brands/BMLogo";
import { CGLogo } from "./brands/CGLogo";
var defaultProps = {
    withClaim: false,
    responsive: false
};
var RESPONSIVE_LOGOS = {
    "billiger-mietwagen": {
        title: "billiger-mietwagen.de",
        height: {
            mobile: 30,
            desktop: 40
        }
    },
    carigami: {
        height: {
            mobile: 22,
            desktop: 40
        },
        title: "CARIGAMI"
    },
    floyt: {
        height: {
            mobile: 22,
            desktop: 40
        },
        title: "FLOYT"
    }
};
var LOGO_COMPONENTS = {
    floyt: {
        height: "54px",
        component: FloytLogo
    },
    "billiger-mietwagen": {
        height: "54px",
        component: BMLogo
    },
    carigami: {
        height: "54px",
        component: CGLogo
    }
};
var BrandLogo = function(param) {
    var brandName = param.brand, width = param.width, height = param.height, responsive = param.responsive, withClaim = param.withClaim;
    var logo = LOGO_COMPONENTS[brandName];
    var LogoComponent = logo.component;
    return /*#__PURE__*/ _jsx(LogoComponent, {
        responsive: responsive,
        withClaim: withClaim,
        width: width,
        height: height !== null && height !== void 0 ? height : logo.height
    });
};
var ResponsiveLogo = function() {
    var baseLocalizedUrl = useHost().baseLocalizedUrl;
    var brandName = useBrand().brandName;
    var isMobile = useMedia("(max-width: ".concat(Theme.getBreakpoint("lg"), "px)"), false);
    var _brandName = RESPONSIVE_LOGOS[brandName], height = _brandName.height, title = _brandName.title;
    return /*#__PURE__*/ _jsx("a", {
        href: baseLocalizedUrl,
        title: title,
        "aria-label": "logo",
        children: /*#__PURE__*/ _jsx(BrandLogo, {
            brand: brandName,
            responsive: true,
            height: "".concat(height[isMobile ? "mobile" : "desktop"], "px"),
            withClaim: !isMobile
        })
    });
};
BrandLogo.defaultProps = defaultProps;
export { BrandLogo, ResponsiveLogo };
